var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue-loading',{attrs:{"type":_vm.type,"color":_vm.color,"size":{ width: '30px', height: '30px' }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }